
import { mapMutations } from 'vuex';
import LoginToggle from '@/components/loginToggle.vue';
import Field from '@/components/ui/field.vue';
import PrimaryButton from '@/components/ui/primaryButton.vue';

export default {
  components: {
    LoginToggle,
    Field,
    PrimaryButton,
  },

  props: {
    message: {
      type: String,
      default: null,
    },
    defaultemail: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      password: null,
      email: null,
      error: null,
      passError: [],
      mailError: [],
      working: false,
      loginMethod: 'link',
      magicLinkMessage: null,
    };
  },

  computed: {
    loginIsLink() {
      return this.loginMethod && this.loginMethod === 'link';
    },
  },

  watch: {
    email() {
      this.mailError = [];
    },
    password() {
      this.passError = [];
    },
    loginMethod() {
      this.magicLinkMessage = null;
    },
  },

  mounted() {
    if (this.defaultemail) {
      this.email = this.defaultemail;
    }
  },

  methods: {
    ...mapMutations([
      'setUser',
      'setToken',
      'setPatientId',
      'setDeliveryAddress',
    ]),
    closeLogin() {
      this.$emit('close');
    },
    toReset() {
      this.closeLogin();
      this.$router.push(this.localePath({ name: 'reset' }));
    },
    login() {
      this.error = null;
      this.mailError = [];
      if (this.email === null || !/(.+)@(.+){2,}\.(.+){2,}/.test(this.email)) {
        this.mailError.push(this.$t('forms.invalidMail'));
        this.working = false;
        return false;
      }
      this.working = true;
      if (this.loginIsLink) {
        this.magicLinkMessage = null;
        this.$bolev
          .sendMagicLink({
            email: this.email,
            redirect: this.$route.path,
          })
          .then(() => {
            this.magicLinkMessage = this.$t('login.reset_request');
            this.working = false;
          })
          .catch(() => {
            this.error = this.$t('global.error');
            this.working = false;
          });
        return;
      }
      this.passError = [];
      if (this.password === null) {
        this.passError.push(this.$t('forms.invalidPassword'));
        this.working = false;
        return false;
      }
      this.$bolev
        .login({
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          this.setToken(res.data.access_token);
          this.$bolev
            .user()
            .then((res) => {
              if (res.data) {
                this.setUser(res.data);
                this.setPatientId(res.data.patientId);
                this.setDeliveryAddress(res.data.deliveryAddress);
                this.closeLogin();
              } else {
                this.error = this.$t('global.error');
              }
              this.working = false;
            })
            .catch(() => {
              this.setToken(null);
              this.error = this.$t('global.error');
              this.working = false;
            });
        })
        .catch((err) => {
          if (err.response && err.response.status < 500) {
            this.passError.push(this.$t('login.invalidCredentials'));
            this.mailError.push(this.$t('login.invalidCredentials'));
          } else {
            this.error = this.$t('global.error');
          }
          this.working = false;
        });
    },
  },
};
